import updateNote_dangerous from 'services/api/endpoints/risikaAPI/notes/resources/updateNote_dangerous'
import { useMutation } from 'react-query'

export function useUpdateNoteDangerous() {
  return useMutation(updateNote_dangerous)
}
